<template>
  <div>
    <el-row>
      <h4>拣货单号：{{ PICK_CODE }}</h4>
      <el-button size="medium" class="btn" @click="printPick">打印拣货单</el-button>
      <el-button size="medium" type="primary" plain class="btn" @click="exportPick">导出拣货单</el-button>
    </el-row>
    <el-row>
      <h2>总拣单</h2>
      <el-col>
        <el-table :data="pickListAll" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="库位" prop="LOCATION_CODE" min-width="100px"></el-table-column>
          <el-table-column label="区域" prop="TYPE_NAME" min-width="100px"></el-table-column>
          <el-table-column label="产品" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="UNIT" min-width="60px"></el-table-column>
          <el-table-column label="数量" prop="PRODUCT_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="生产日期" prop="PRODUCTION_DATE" min-width="100px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  print, WMShistoryPickListDetail, WMShistoryExportPickListDetail,
} from '@/assets/api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      totalCount: 0,
      searchForm: {},
      pickListAll: [],
      pick_id: '',
      PICK_CODE: this.$route.params.PICK_CODE,
    };
  },
  created() {
    this.queryHistoryPick();
  },
  methods: {
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    queryHistoryPick() {
      const params = {
        PICK_CODE: this.PICK_CODE,
      };
      WMShistoryPickListDetail(params).then((result) => {
        this.pickListAll = result.map((item) => Object.assign(item, {
          PRODUCT_CODE: item.PRODUCT_CODE.toString(),
        }));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    printPick() {
      this.mergePostion();

      const html = `
        <div>
          <div class="main">
            <div class="title">总拣单</div>
            <div class="head">
              <div class="code">单号：${this.PICK_CODE}</div>
            </div>
            <table border="1" cellspacing="0">
              <div class="el-table__body el-table__header">
                <tr>
                  <th style="width: 50px">序号</th>
                  <th style="width: 100px">库位</th>
                  <th style="width: 50px">区域</th>
                  <th>产品</th>
                  <th style="width: 40px">单位</th>
                  <th style="width: 70px">总数</th>
                  <th style="width: 100px">生产日期</th>
                </tr>
              </div>
              <div class="el-table__body">
              ${this.pickListAll.map((item, index) => (item.count ? `
                <tr style="text-align: center">
                  <td>${index + 1}</td>
                  <td rowspan="${item.count}">${item.LOCATION_CODE}</td>
                  <td>${item.TYPE_NAME}</td>
                  <td>${item.NAME}</td>
                  <td>${item.UNIT}</td>
                  <td>${item.PRODUCT_COUNT}</td>
                  <td>${item.PRODUCTION_DATE}</td>
                </tr>
              ` : `
                <tr style="text-align: center">
                  <td>${index + 1}</td>
                  <td>${item.TYPE_NAME}</td>
                  <td>${item.NAME}</td>
                  <td>${item.UNIT}</td>
                  <td>${item.PRODUCT_COUNT}</td>
                  <td>${item.PRODUCTION_DATE}</td>
                </tr>
              `))}
              </div>
            </table>
          </div>
        </div>
      `;
      // eslint-disable-next-line no-unused-vars
      const windows = print(html);
      // windows.close()
    },
    // 按库位合并单元格
    mergePostion() {
      let now_postion = null;
      let start_index = 0;
      let count = 1;
      for (let i = 0; i < this.pickListAll.length; i++) {
        if (this.pickListAll[i].LOCATION_CODE !== now_postion) {
          this.pickListAll[start_index].count = count;
          count = 1;
          this.pickListAll[i].count = count;
          start_index = i;
          now_postion = this.pickListAll[i].LOCATION_CODE;
        } else {
          count += 1;
          this.pickListAll[start_index].count = count;
        }
      }
    },
    exportPick() {
      const params = {
        PICK_CODE: this.PICK_CODE,
      };
      WMShistoryExportPickListDetail(params).then((res) => {
        window.open(this.$util.getURLLocalHost(res[0].URL));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },

};
</script>
<style  scoped>
.el-select {
  margin-right: 15px;
}

.el-input {
  margin-right: 15px;
  width: 200px;
}

.tableArea {
  margin-top: 20px;
}

i[class^="el-icon"] {
  margin-right: 5px;
  font-size: 16px;
  cursor: pointer;
}

.modify_table td {
  padding: 10px;
}

.item_title {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/pickingListDetail.vue